<span class="CeTooltip u-border-radius-sm u-spacing-xs-pv u-spacing-sm-ph u-spacing-sm-pa u-text-body-xs {{ classList }}" [@fadeInOutVoid] [class.hide]="hide">{{ text }}</span>
